export const USER_TYPE = {
  Internal: "Internal",
  External: "External",
  StakeHolder: "StakeHolder",
};

export const PERMISSION_CODE = {
  User: "CPM-USER",
  Admin: "CPM-ADMIN",
  ASCManageReq: "CPM-ASC",
  AdminERD: "CPM-ADMIN-ERD",
};

export const MENU_ID = {
  Home: "topbarHomepage",
  Complaint: "topbarComplaint",
  ComplaintStatus: "topbarComplaintStatus",
  Admin: "topbarAdmin",
  ComplaintList: "topbarComplaintList",
  // AdminFlight: "topbarAdminFlight",
  ComplaintOcpb: "topbarComplaintOcpb",
  ComplaintOpm: "topbarComplaintOpm",
};
